module.exports = __webpack_public_path__ + "img/australia-ischemic-heart-disease-female.b8339073.png";